import { Injectable, signal } from '@angular/core';

import { ErrorAnnotations } from '@core/models/error-catalog.model';

const NONE: ReadonlyMap<string, ErrorAnnotations> = new Map();

/**
 * DataLayer's per-code title, message template and enum labels, once something has loaded
 * them. Holding is separate from fetching on purpose: the warning presenter reads this from
 * inside a `computed`, and every consumer of a finding sits downstream of it — giving the
 * presenter an HTTP dependency would put one in the dependency graph of every component
 * that renders a warning.
 *
 * Empty until `ErrorCatalogLoader` fills it, and empty forever if the catalog cannot be
 * reached. Every annotation is optional, so a finding still renders through GFE's own
 * translations and DataLayer's prose.
 */
@Injectable({ providedIn: 'root' })
export class ErrorCatalogService {
  private readonly _annotations = signal<ReadonlyMap<string, ErrorAnnotations>>(NONE);

  readonly annotations = this._annotations.asReadonly();

  setAnnotations(annotations: ReadonlyMap<string, ErrorAnnotations>): void {
    this._annotations.set(annotations);
  }

  /** The annotations DataLayer publishes for `code`, or `undefined` if it publishes none. */
  forCode(code: string): ErrorAnnotations | undefined {
    return this._annotations().get(code);
  }
}
